import { ActionButton, Groups } from '../../models';
import { AppKeys, newMsg } from '../../core/localization';
import * as ReadRights from '../../modules/dialogs/readRights';
import * as Download from '../../modules/dialogs/download';
import * as Register from '../../modules/dialogs/register';
import * as Transfer from '../../modules/dialogs/transfer';
import { Modals } from '../../modules/dialogs/model';
import { setModal } from '../../modules/dialogs/actions';
import { TransferDialogs } from '../../modules/dialogs/transfer';

const subtitleByGroup = (total: number, groupedBy = Groups.DEVICES) => {
  let messageKey: string = AppKeys.Num_Device;
  switch (groupedBy) {
    case Groups.ORDERS:
      messageKey = AppKeys.Num_Order;
      break;
    default:
      break;
  }
  return newMsg(messageKey, [{ tag: 'count', value: total }]);
};

export const readRightsRoot = (): ActionButton => ({
  id: 'readrights',
  title: newMsg(AppKeys.Btn_ReadRights),
});
/*
export const readRightsAll = (
  total: number,
  groupedBy = Groups.DEVICES
): ActionButton => ({
  id: 'readrightsAll',
  title: newMsg(AppKeys.Selection_All),
  subtitle: subtitleByGroup(total, groupedBy),
  onClick: () => ReadRights.initDialog(groupedBy),
}); */

export const readRightsSelected = (
  keys: string[],
  groupedBy = Groups.DEVICES
): ActionButton => ({
  id: 'readrightsSelected',
  title: newMsg(AppKeys.Selection_Selected),
  subtitle: subtitleByGroup(keys.length, groupedBy),
  onClick: () => ReadRights.initDialog(groupedBy, keys),
});

export const downloadRoot = (): ActionButton => ({
  id: 'download',
  title: newMsg(AppKeys.Btn_Download),
});
/*
export const downloadAll = (
  total: number,
  groupedBy = Groups.DEVICES
): ActionButton => ({
  id: 'downloadAll',
  title: newMsg(AppKeys.Selection_All),
  subtitle: subtitleByGroup(total, groupedBy),
  onClick: () => Download.initDialog(groupedBy),
}); */

export const downloadSelected = (
  keys: string[],
  groupedBy = Groups.DEVICES
): ActionButton => ({
  id: 'downloadSelected',
  title: newMsg(AppKeys.Selection_Selected),
  subtitle: subtitleByGroup(keys.length, groupedBy),
  onClick: () => Download.initDialog(groupedBy, keys),
});

export const activateDevice = (): ActionButton => ({
  id: 'activateDevice',
  title: newMsg(AppKeys.Btn_Activate),
  subtitle: '',
  onClick: () => setModal(Modals.DEVICE_ACTIVATE),
});

export const removeDevice = (): ActionButton => ({
  id: 'removeDevice',
  title: newMsg(AppKeys.Btn_Remove),
  subtitle: '',
  onClick: () => setModal(Modals.DEVICE_REMOVE),
});

export const registerDevice = (): ActionButton => ({
  id: 'registerDevice',
  title: newMsg(AppKeys.Btn_Register),
  subtitle: '',
  onClick: () => Register.openRegisterDialog(),
});

export const transferDevices = (): ActionButton => ({
  id: 'transferDevices',
  title: newMsg(AppKeys.Btn_Transfer),
  subtitle: '',
  onClick: () => Transfer.openTransferDialog(),
});


export const transferRoot = (): ActionButton => ({
  id: 'transfer',
  title: newMsg(AppKeys.Btn_Transfer),
});

export const transferSend = (): ActionButton => ({
  id: 'transferSend',
  title: newMsg(AppKeys.Tx_Send),
  subtitle: '',
  onClick: () => Transfer.changeScreen(TransferDialogs.SEND),
});

export const transferRequest = (): ActionButton => ({
  id: 'transferRequest',
  title: newMsg(AppKeys.Tx_Req),
  subtitle: '',
  onClick: () => Transfer.changeScreen(TransferDialogs.REQUEST),
});

export const transferActivities = (): ActionButton => ({
  id: 'transferActivities',
  title: newMsg(AppKeys.Tx_Act),
  subtitle: '',
  onClick: () => Transfer.changeScreen(TransferDialogs.ACTIVITIES),
});